
import { Component, Prop, Vue } from "vue-property-decorator";
import { ISolCustomerVehicleResponse } from "@/services/backend/sol_customer";

@Component({
  name: "firm-vehicle",
  components: {},
})
export default class FirmsVehicle extends Vue {
  @Prop() public vehicle!: ISolCustomerVehicleResponse | undefined;

  constructor() {
    super();
  }
}
